const LOG_LEVELS = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    silent: 4,
};
function getLogLevel() {
    if (typeof window !== 'undefined' && window.PPTX_LOG_LEVEL) {
        return window.PPTX_LOG_LEVEL;
    }
    if (typeof process !== 'undefined' && process.env?.PPTX_LOG_LEVEL) {
        return process.env.PPTX_LOG_LEVEL;
    }
    return 'warn';
}
function shouldLog(level) {
    const currentLevel = getLogLevel();
    return LOG_LEVELS[level] >= LOG_LEVELS[currentLevel];
}
const log = {
    debug: (...args) => {
        if (shouldLog('debug')) {
            console.debug('[DEBUG]', ...args);
        }
    },
    info: (...args) => {
        if (shouldLog('info')) {
            console.info('[INFO]', ...args);
        }
    },
    warn: (...args) => {
        if (shouldLog('warn')) {
            console.warn('[WARN]', ...args);
        }
    },
    error: (...args) => {
        if (shouldLog('error')) {
            console.error('[ERROR]', ...args);
        }
    },
};
export default log;
//# sourceMappingURL=log.js.map